import { getWalletConfig } from "../api/wallet";

export const walletMessageType = "WALLET";
export const SET_WALLET_CONFIG = "SET_WALLET_CONFIG";
export const CLEAR_WALLET_CONFIG = "CLEAR_WALLET_CONFIG";
export const SET_WALLET_CONFIG_ERR = "SET_WALLET_CONFIG_ERR";

export function clearWalletConfig() {
  return { type: CLEAR_WALLET_CONFIG };
}

export function setWalletConfigErr(err) {
  return { type: SET_WALLET_CONFIG_ERR, error: err };
}

export function setWalletConfig(activeDivisionId) {
  return async (dispatch) => {
    try {
      const fetchedConfig = await getWalletConfig({
        messageType: walletMessageType,
        activeDivisionId,
      });
      dispatch({ type: SET_WALLET_CONFIG, newConfig: fetchedConfig });
    } catch (err) {
      dispatch(setWalletConfigErr(err.message));
    }
  };
}
